/// <reference path="../_all.ts" />

module misc {

  carrouselPreloaderDirective.$inject = [];

  export function carrouselPreloaderDirective(
  ): ng.IDirective {

    return {
      restrict: 'A',
      link: function (scope: any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        var imgDiv = angular.element(element)[0];      
        scope.registerImg($(element).parent().children("div").index(element), imgDiv.getAttribute("preloader-bg"));
        //img.onload = () => {
        //  imgDiv.setAttribute("style", "background-image: url(\"" + imgDiv.getAttribute("preloader-bg") + "\")");            
        //  imgDiv.removeAttribute("preloader-bg");
        //}
      }
    }

  }
}